/**
 * Komunikace (modul `zpravy`) — sdílené konstanty a drobnosti.
 *
 * Barva je barva sekce **Tým** z katalogu (`moduly.json`), stejně jako u Lidí.
 * Dřív měl chat vlastní oranžovou natvrdo v pěti souborech.
 */
export const SECTION_COLOR = '#B47AEA';
export const SECTION_BG = 'rgba(180,122,234,0.12)';
export const SECTION_BORDER = 'rgba(180,122,234,0.45)';

/** 1 člověk, 2–4 lidé, 5+ lidí. */
export const pocetLidi = (n) => `${n} ${n === 1 ? 'člověk' : n < 5 ? 'lidé' : 'lidí'}`;

/** Čas v seznamu: dnes hodiny, jinak den a měsíc. */
export function formatCasListu(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    const now = new Date();
    const dnes = d.toDateString() === now.toDateString();
    if (dnes) return d.toLocaleTimeString('cs', { hour: '2-digit', minute: '2-digit' });
    return `${d.getDate()}. ${d.getMonth() + 1}.`;
}

/** Hlavičky pro zapisující požadavky chatu (CSRF + socket, ať se vlastní broadcast nevrací). */
export function hlavicky(json = true) {
    return {
        ...(json ? { 'Content-Type': 'application/json' } : null),
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content,
        'X-Socket-ID': window.Echo?.socketId?.() ?? '',
        Accept: 'application/json',
    };
}

/** Druhý účastník soukromé konverzace. */
export const druhyUcastnik = (k, userId) => (k?.typ === 'soukromy' ? k.ucastnici?.find(u => u.id !== userId) : null);

/** Čas směny „16:00" z „16:00:00". */
export const casSmeny = (t) => (t || '').toString().slice(0, 5);
